import React, { useEffect, useRef, useState } from 'react'

export function Accordion({ header, body, className, togglerRef = {} }) {
    const [collapsed, setCollapsed] = useState(true)
    const headerRef = useRef(null)

    const toggleCollapsed = () => setCollapsed(!collapsed)

    useEffect(() => {
        if (!togglerRef?.current) {
            togglerRef.current = headerRef.current
        }
    }, [togglerRef, headerRef])

    useEffect(() => {
        const el = togglerRef?.current

        if (el) {
            el.addEventListener('click', toggleCollapsed)

            return () => {
                el.removeEventListener('click', toggleCollapsed)
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [togglerRef])

    return (
        <div className={`accordion ${collapsed ? 'closed' : 'open'} ${className}`}>
            <div className="accordion-header" ref={headerRef}>
                {header}
            </div>
            {!collapsed && <div className="accordion-body">{body}</div>}
        </div>
    )
}
